// frontend/src/modules/esign/pdf.ts
//
// Thin pdf.js loader shared by the field-placement editor (this task) and the
// signer page (Task 9). Uses the **legacy** build (broadest browser/CRA
// compatibility) and points the worker at the bundled worker script via a
// `new URL(..., import.meta.url)` asset reference — CRA5/webpack5 resolves
// this to a hashed, separately-emitted file at build time, which is what
// proves the worker actually ships (see `npm run build` in the task report).
import * as pdfjs from 'pdfjs-dist/legacy/build/pdf';
import type { PDFDocumentProxy } from 'pdfjs-dist';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/legacy/build/pdf.worker.min.js',
  import.meta.url,
).toString();

export type { PDFDocumentProxy, PDFPageProxy } from 'pdfjs-dist';

export async function loadPdf(data: ArrayBuffer): Promise<PDFDocumentProxy> {
  const loadingTask = pdfjs.getDocument({ data });
  return loadingTask.promise;
}
